import { render, staticRenderFns } from "./QuestionConfigMediaImage.vue?vue&type=template&id=48fe2794&scoped=true"
import script from "./QuestionConfigMediaImage.vue?vue&type=script&lang=js"
export * from "./QuestionConfigMediaImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fe2794",
  null
  
)

export default component.exports